export function is16DigitNumberString(inputString: string): boolean {
  const strippedString = inputString?.replace(/\s/g, '');
  if (/^\d+$/.test(strippedString)) {
    if (strippedString.length === 16) {
      return true;
    }
  }
  return false;
}
